import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "duvar",
  name: "Duvar",
  tagline: "Blokları ok yönünde kaydır, duvarın arkasındaki resmi az dokunuşta bil.",
  inspiredBy: "3D tap-away block puzzle",
  secondLayer: "A hidden picture behind the wall: open the right columns, tilt to peek, guess early.",
  accent: "#6a4c93",
  status: "lab",
};
